import type { StencilRouteContentSnapshot, StencilRouteContentStatus } from './stencil-route-content.model';

export const hasStencilRouteContentChanged = (
    currentSnapshot: StencilRouteContentSnapshot,
    startSnapshot: StencilRouteContentSnapshot
): boolean => {
    if (currentSnapshot.text !== startSnapshot.text) {
        return true;
    }

    if (currentSnapshot.elements.size !== startSnapshot.elements.size) {
        return true;
    }

    return [...currentSnapshot.elements].some((element) => !startSnapshot.elements.has(element));
};

export const hasPendingStencilRouteContent = ({
    hasUnhydratedStencilContent,
    hasVisibleBusyContent,
}: StencilRouteContentStatus): boolean => hasUnhydratedStencilContent || hasVisibleBusyContent;
